import { createAction, createSlice } from "@reduxjs/toolkit";

export default function getFileManagement() {
    const fileManagementSlice = createSlice({
        name: "fileManagement",
        initialState: {
            type: null,
            totalFile: 0,
            data: []
        },
        reducers: {
            startSyncing: (state, action) => {
                return {
                    ...state,
                    totalFile: action.payload.totalFile,
                    data: action.payload.data,
                    type: 'syncing'
                };
            },
            startSyncingFolders: (state) => {
                return {
                    ...state,
                    type: 'syncingFolders'
                };
            },
            syncingFoldersComplete: (state) => {
                return {
                    ...state,
                    type: null
                };
            },
            findAndUpdateSyncing: (state, action) => {
                state.data = state.data.map(({ file, answer, ...rest }) => {
                    if (
                        file.originalname === action.payload.file.originalname &&
                        answer.qNo === action.payload.answer.qNo
                    ) {
                        return action.payload; // replace with new payload
                    }
                    return { file, answer, ...rest, type: 'syncing' }; // keep as is
                });
            },
            resetSyncing: (state) => {
                state.totalFile = 0;
                state.data = [];
                state.type = null
            },
            startReSyncing: (state, action) => {
                return {
                    ...state,
                    totalFile: action.payload.totalFile,
                    data: action.payload.data,
                    type: 'reSyncing'
                };
            },
            findAndUpdateReSyncing: (state, action) => {
                const incoming = action.payload?.data?.answer;
                if (!incoming) return;
                const incomingId = incoming._id != null ? String(incoming._id) : null;
                const incomingQNo = incoming.qNo != null ? String(incoming.qNo) : null;
                state.data = state.data.map((answer) => {
                    const answerId = answer._id != null ? String(answer._id) : null;
                    const matchById = incomingId && answerId && answerId === incomingId;
                    const matchByQNo = incomingQNo && answer.qNo != null && String(answer.qNo) === incomingQNo;
                    if (matchById || matchByQNo) {
                        return { ...answer, processed: true };
                    }
                    return answer;
                });
            },
            resetReSyncing: (state) => {
                state.totalFile = 0;
                state.data = [];
                state.type = null
            }
        }
    });

    return fileManagementSlice.reducer;
}

export const startSyncing = createAction("fileManagement/startSyncing");
export const startSyncingFolders = createAction("fileManagement/startSyncingFolders");
export const syncingFoldersComplete = createAction("fileManagement/SyncingFoldersComplete");
export const findAndUpdateSyncing = createAction("fileManagement/findAndUpdateSyncing");
export const resetSyncing = createAction("fileManagement/resetSyncing");

export const startReSyncing = createAction("fileManagement/startReSyncing");
export const findAndUpdateReSyncing = createAction("fileManagement/findAndUpdateReSyncing");
export const resetReSyncing = createAction("fileManagement/resetReSyncing");